<app-grades-selector [routeOnClick]="true"> </app-grades-selector>

<router-outlet></router-outlet>
